function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.7529 1.25C16.001 1.25018 20.2549 5.50481 20.2549 10.7529C20.2547 16.0009 16.0009 20.2547 10.7529 20.2549C5.50481 20.2549 1.25018 16.001 1.25 10.7529C1.25 5.50471 5.50471 1.25 10.7529 1.25Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.00026
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7526 6.75156H10.7606M10.7526 14.7536V9.75234M20.7552 10.7526C20.7552 16.277 16.277 20.7552 10.7526 20.7552C5.22817 20.7552 0.75 16.277 0.75 10.7526C0.75 5.22817 5.22817 0.75 10.7526 0.75C16.277 0.75 20.7552 5.22817 20.7552 10.7526Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.50039,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPrimary);
export default __webpack_public_path__ + "static/media/infoPrimary.0973effacad25b38a6fc474e2df38450.svg";
export { ForwardRef as ReactComponent };